module.exports = __webpack_public_path__ + "img/icon_load_more.701327c7.svg";